<template>
    <main-layout>
        <div class="container">
            <H1 class="has-text-primary is-size-3">DASHBOARD</H1>
            <div class="limitWidth">
                <hr/>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Subscriptions.vue